const SERVER_IP = process.env.REACT_APP_DEV_API;
const MAIN_ROUTE = 'api/v1';

export const SERVER_PATH = `${SERVER_IP}/${MAIN_ROUTE}`;
export const ROOT_URL = `${SERVER_PATH}`;

// Login url
export const LOGIN_API = `${ROOT_URL}/user/login`;

// User Verified url
export const OTP_USER_VERIFY_API = `${ROOT_URL}/user/otp/verify`;
export const FORGOT_PASSWORD_EMAIL_API = `${ROOT_URL}/user/forget/pass/s_mail`;
export const FORGOT_PASSWORD_EMAIL_VERIFY = `${ROOT_URL}/user/confirm/p_link`;
export const FORGOT_PASSWORD_UPDATE = `${ROOT_URL}/user/forget/pass/update`;
export const AUTH_VERIFY = `${ROOT_URL}/user/auth/verify`;
export const NEW_USER_TOKEN_VERIFY = `${ROOT_URL}/user/confirm/e_link`;
export const NEW_USER_REGISTRATION = `${ROOT_URL}/user/new`;
export const NEW_USER_REGISTRATION_OTP_VERIFY = `${ROOT_URL}/user/verify-otp`;
export const USER_REGISTRATION_VERIFY = `${ROOT_URL}/user/confirm/a_link`;
export const GET_USER_TENANT_ID = `${ROOT_URL}/tenant-ids`;
export const GET_USER_TENANT_ID_WITH_NAMES = `${ROOT_URL}/tenant-ids-with-names`;
export const USER_TENANT_ID_SELECT_VERIFY = `${ROOT_URL}/user/tenant-id/select`;
export const CONFIG_PASSWORD_POLICY = `${ROOT_URL}/sys/config/passwordPolicy`;
